import React, { useMemo } from "react";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import ResumeUnderlineIconSVG from "assets/svg/resume-underline-icon";
import ResumeDotDividerIconSVG from "assets/svg/resume-dot-divider-icon";
import { BsExclamationDiamondFill } from "react-icons/bs";
import { renderStartDate, renderEndDate } from "../../resume";
import _ from "lodash";
import ItemMilestone from "../../preview/template-two-tg/item-milestone";
import { QRResume_TEMP_2 } from "../../qr-code/qr-resume";
import { A4_SIZE } from "../../resume";

export default function TemplateTwoFullPageTwo({
  page = 2,
  color,
  milestones = {},
  primaryColor,
  tertiaryColor,
  quarternary,
  show_image_milestone=true,
  profile,
  item=[],
  totalPage,
  show_qr_milestone,
  show_qr_reels,
  milestone_position=[]
}) {
  const [pageBGActive, pageBGInactive] = useMemo(() => {
    if (color.label === "Blue + Orange") {
      return [tertiaryColor, "#16438A"];
    } else if (color.label === "Green + Yellow") {
      return ["#FFFFFF", "#000000"];
    } else if (color.label === "Pink + Dark Pink") {
      return ["#FFFFFF", tertiaryColor];
    }
    return ["#FFFFFF", "#000000"];

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  return (
    <div className="w-full" style={A4_SIZE}>
      {/* start body */}
      <div
        className="w-full h-full grid bg-white relative grid-row-auto">
        {/* body */}
        <div className="w-full px-21 pt-10.5">
            <div>
              <ItemMilestone
                {...{
                  primaryColor,
                  tertiaryColor , 
                  profile,
                  show_image_milestone,
                }}
                headerType = 'featured'
                items={item}
                milestone_position={milestone_position}
                fullPreview = {true}
                />
                <ItemMilestone
                {...{
                  primaryColor,
                  tertiaryColor , 
                  profile,
                  show_image_milestone
                }}
                headerType = 'current'
                items={item}
                milestone_position={milestone_position}
                fullPreview = {true}
                />
              <ItemMilestone
                {...{
                  primaryColor,
                  tertiaryColor , 
                  profile,
                  show_image_milestone
                }}
                headerType = 'past'
                items={item}
                fullPreview = {true}
                milestone_position={milestone_position}
                />
            </div>
            
            {totalPage === page && 
                <QRResume_TEMP_2 {...{show_qr_milestone,show_qr_reels}} />
            }
        </div>
        {/* footer */}
        <div className="w-full pt-10 flex items-end">
          <div
            className="w-full h-7.5 px-21 relative"
            style={{ backgroundColor: quarternary }}>
            <div className="w-full h-full flex flex-row justify-between items-center">
              <p className="text-white font-semibold text-6xs">Page {page}</p>
              <div className="flex flex-start gap-1.5">
                <button
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: pageBGInactive }}
                />
                <button
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: pageBGActive }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
